import(/* webpackMode: "eager" */ "/var/www/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/var/www/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/var/www/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/var/www/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/src/app/components/cookie-consent-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/src/app/components/page-view-tracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/src/app/components/statsig.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/src/app/datadog-init.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/src/app/globals.css");
